import { number } from 'prop-types';

import { userFormType } from './formTypes';

export const surveyType = {
  form: {
    ...userFormType
  },
  survey_history_id: number
};
